import { produce } from "immer";
import {
  SET_PID_QUERY_SUCCESS,
  SET_PID_TABS_SUCCESS,
} from "../events/pidEvents";

const initialState = {
  query: "",
  tabs: [],
};

const pidReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PID_QUERY_SUCCESS: {
      const { query } = action.payload;
      return produce(state, (draft) => {
        draft.query = query;
      });
    }

    case SET_PID_TABS_SUCCESS: {
      const { tabs } = action.payload;
      return produce(state, (draft) => {
        draft.tabs = tabs;
      });
    }

    default: {
      return state;
    }
  }
};

export default pidReducer;
